export default __webpack_public_path__ + "static/media/log.614c31cf.png";